const ACTIVE_KEY = 'spate:chat:activeId';

export const sessionStorage = {
    getActiveId(): string | null {
        try {
            return window.sessionStorage.getItem(ACTIVE_KEY);
        } catch {
            return null;
        }
    },

    setActiveId(id: string | null): void {
        try {
            if (id) {
                window.sessionStorage.setItem(ACTIVE_KEY, id);
            } else {
                window.sessionStorage.removeItem(ACTIVE_KEY);
            }
        } catch {
            // sessionStorage unavailable
        }
    },
};
